import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  sectionId: string;
  kitId: string;
  // It would be cool if we could append this to the action from state, but createAsyncAction won't let us define generic Meta.
  fromKitId: string;
};

const [useMoveSection, moveSection] = createAsyncAction(
  "sections/move",
  async ({ sectionId, kitId }: Args) => {
    const res = await API.call<{ section: string }>({
      endpoint: `/sections/${sectionId}/move`,
      method: "PUT",
      data: { kit_uuid: kitId },
    });
    return { ...res, result: res.result.section };
  }
);

export default useMoveSection;
export { moveSection };
